import React from 'react'

export default function Invoice(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="#747894" {...props}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 2v6h6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 13H8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16 17H8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
}
